import styled from '@emotion/styled'

export const PhoneInputWrapper = styled.div<{ isDisabled?: boolean; isError?: boolean }>`
  width: 100%;

  .react-tel-input .form-control {
    width: 100% !important;
    border: 2px solid ${({ isError }) => (isError ? '#EE533D' : '#e7e6e4')} !important;
    background-color: ${({ isError }) => (isError ? '#FFE4DA' : 'transparent')} !important;
    padding: 1rem 1rem 1rem 3.5rem !important;
    font-weight: 500 !important;
    font-size: 1rem !important;
    line-height: 1.2 !important;
    border-radius: 0.5rem !important;
    height: auto !important;
    font-family: inherit !important;
    color: inherit !important;

    ${({ isDisabled }) => isDisabled && 'background-color: #F3F3F2 !important; border-color: #E7E6E4 !important;'}

    &:focus {
      border-color: #000000 !important;
      outline: none !important;
      box-shadow: none !important;
    }

    &::placeholder {
      color: #a7a6a4 !important;
      font-weight: 500 !important;
    }
  }

  .react-tel-input .flag-dropdown {
    border: 2px solid ${({ isError }) => (isError ? '#EE533D' : '#e7e6e4')} !important;
    border-right: none !important;
    border-radius: 0.5rem 0 0 0.5rem !important;
    background-color: ${({ isError }) => (isError ? '#FFE4DA' : 'white')} !important;

    ${({ isDisabled }) => isDisabled && 'background-color: #F3F3F2 !important; border-color: #E7E6E4 !important;'}

    &:hover,
    &.open {
      background-color: #f3f3f2 !important;
    }
  }

  .react-tel-input .selected-flag {
    border-radius: 0.5rem 0 0 0.5rem !important;
    padding: 0 0 0 0.75rem !important;

    &:hover,
    &:focus {
      background-color: #f3f3f2 !important;
    }
  }

  .react-tel-input .flag {
    width: 20px !important;
    height: 15px !important;
    overflow: hidden !important;

    svg,
    img {
      width: 20px !important;
      height: 15px !important;
      display: block !important;
    }
  }

  .react-tel-input .country-list {
    max-height: 220px !important;
    overflow-y: scroll !important;
  }
`
